import {Html5QrcodeScanner, Html5Qrcode} from "html5-qrcode"

function initHtml5QrcodeScanner (barcode={}) {

  const html5QrCode = new Html5Qrcode("reader");

  const { url, redirect_enabled, event_id, id } = barcode;

  var lastResult = null;
   
  const qrCodeSuccessCallback = (decodedText, decodedResult) => {
    var urlObject = false;
    var validURL = false;
    try {
      urlObject = new URL(decodedText);
      validURL = true;
      var originPathName = `${urlObject.origin}${urlObject.pathname}`
      if (url && !url.includes(originPathName)) {
        alert('Invalid URL');
        validURL = false;
      }
    } catch (e) {
      if (e.message.includes('Invalid URL')) {
        alert('Invalid URL');
      } else {
        alert('Unknown error');
      }
    } 

    if (!validURL) {
      return;
    }

    // navigate to the URL
    if (lastResult !== decodedText) {
      lastResult = decodedText;
      window.location.href = decodedText
    }
  };
  
  const config = { 
    fps: 10, 
    qrbox: { 
      width: 250, 
      height: 250 
    } 
  };

  function handleStartError (error) {
    if (error.includes('Permission denied')) {
      alert('Please allow camera access to scan QR codes')
    }
  }
  
  // If you want to prefer back camera
  html5QrCode.start({ 
    facingMode: "environment" 
  }, config, qrCodeSuccessCallback).catch(handleStartError);
}

export default {
  initHtml5QrcodeScanner
}